import { styled } from '@mui/material/styles'
import MuiCircularProgress from '@mui/material/CircularProgress'

export const CircularProgress = styled(MuiCircularProgress, {
  name: 'CircularProgress',
  slot: 'Root',
  skipSx: true,
})`
  margin: auto;
`
